'use client';

import styled from 'styled-components';

import { useSearchResultsContext } from '../context/SearchResultsContext';
import Button from '@/ui/components/Button';
import Loader from '@/ui/components/Loader';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledButton = styled(Button)`
  position: relative;
`;

const StyledLoader = styled.div`
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);

  svg {
    stroke: black !important;
  }
`;

const NoWrap = styled.span`
  white-space: nowrap;
`;

/**
 * @todo translation
 */
export default function LoadMoreButton() {
  const { loadMoreSearchResults, isLoadingMoreResults, noMoreResults, searchResults } = useSearchResultsContext();

  if (!searchResults.length) {
    return null;
  }

  if (searchResults.length < 10) {
    return null;
  }

  if (noMoreResults) {
    return (
      <Wrapper>
        <Button variant="outlined" disabled sx={{ width: '12rem' }}>
          No more results
        </Button>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {isLoadingMoreResults ? (
        <StyledButton variant="outlined" sx={{ width: '12rem' }}>
          <NoWrap>Show more</NoWrap>
          <StyledLoader>
            <Loader size={20} />
          </StyledLoader>
        </StyledButton>
      ) : (
        <Button onClick={loadMoreSearchResults} sx={{ width: '12rem' }}>
          Show more
        </Button>
      )}
    </Wrapper>
  );
}
